import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { StudentSummaryVM } from "@shared-kernel/application/ports/student/student-repository";

export const retrieveStudentSummary = createAsyncThunk<StudentSummaryVM, string | undefined, { extra: Partial<Dependencies> }>(
  "students/retrieveStudentSummary",
  async (studentId: string | undefined, { extra: { studentRepository, adminRepository } }) => {
    if (studentId) return adminRepository!.getStudentSummary(studentId);
    return studentRepository!.summary();
  },
);
